<template>
    <div>
        <SignUp/>
    </div>
</template>


<script>
    import SignUp from '@/components/laptop/Authorization/SignUp.vue';

    export default {
        name: "SignUpView",
        components: {
            SignUp
        },
        data() {
            return {

            }
        },
        methods: {
            loadData() {
                if (this.isAuthorized) {
                    this.$router.push({ name: 'role' }); 
                }
            },
        },
        mounted() {
            this.loadData();
        }
    }
</script>